export enum QuestionType {
  RADIO = 'radio',
  RADIO_IMAGE = 'radio_image',
  DROPDOWN = 'dropdown',
  BOOL = 'bool',
  NUMBER = 'number',
  LONG_TEXT = 'long_text',
  MATRIX = 'matrix'
}
